import React from "react";

import { useIntl } from "react-intl";

import { formatAsCurrency } from "Libs/utils";

import TableWrapper from "../Table";

import * as S from "./InvoiceOrganization.styles";

import type { OrderLineItem } from "@packages/client";
import type { MomentInput } from "moment";

const InvoiceOrganization = ({
  durationDate,
  orderCurrency,
  organizationItems
}: {
  organizationItems: OrderLineItem[];
  orderCurrency: string;
  durationDate: (date: MomentInput) => string;
}) => {
  const intl = useIntl();

  if (!organizationItems || organizationItems.length === 0) {
    return null;
  }

  return (
    <S.InvoiceOrganizationWrapper>
      <S.Title>
        {intl.formatMessage({
          id: `billing.invoice.organization`
        })}
      </S.Title>
      <TableWrapper
        headers={["Items", "Duration", "Unit price", "Usage", "Total"]}
      >
        {organizationItems.map(lineItem => (
          <tr key={lineItem.id}>
            <S.BigTD>
              <S.TableCell className={lineItem.product.toLowerCase()}>
                {lineItem.product}
                {lineItem.custom_description && (
                  <small>{lineItem.custom_description}</small>
                )}
              </S.TableCell>
            </S.BigTD>

            <S.SmallTD>
              <S.TableSmallCell>{`${durationDate(
                lineItem.start
              )} – ${durationDate(lineItem.end)}`}</S.TableSmallCell>
            </S.SmallTD>

            <S.SmallTD>
              <S.TableSmallCell>
                {formatAsCurrency(lineItem.unit_price, orderCurrency)}
              </S.TableSmallCell>
            </S.SmallTD>

            <S.SmallTD>
              <S.TableSmallCell>
                {(typeof lineItem.quantity === "string"
                  ? parseFloat(lineItem.quantity)
                  : lineItem.quantity
                ).toFixed(2)}
              </S.TableSmallCell>
            </S.SmallTD>

            <S.TD>
              <S.TableTotalCell>
                {formatAsCurrency(
                  lineItem?.components?.base_price.amount,
                  orderCurrency
                )}
              </S.TableTotalCell>
            </S.TD>
          </tr>
        ))}
      </TableWrapper>
    </S.InvoiceOrganizationWrapper>
  );
};

export default InvoiceOrganization;
